import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-preview-document",
  templateUrl: "./preview-document.component.html",
  styleUrls: ["./preview-document.component.scss"],
})
export class PreviewDocumentComponent implements OnInit {
  previewTitle: string;
  previewUrl: any;
  isFrame: boolean;

  constructor(
    public dialogRef: MatDialogRef<PreviewDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    if (data) {
      this.previewTitle = data.documentTitle
        ? data.documentTitle
        : data.documentLocation && data.documentLocation.name
        ? data.documentLocation.name
        : "Document Preview";
      this.previewUrl = data.documentLocation;
      this.isFrame = data.isFrame;
      //console.log('file', data.documentLocation);
    }
  }

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  getSecuredURL() {
    if (typeof this.previewUrl == "string" && !this.isFrame) this.previewUrl;

    // const url = URL.createObjectURL(this.previewUrl);
    const url = this.previewUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  download(url: string, name: string) {
    FileSaver.saveAs(this.getSecuredURL(), this.previewTitle);
  }
}
